import React, { useState } from "react";
import PropTypes from "prop-types";

import ModalType from "../Modal/type";
import Modal from "../Modal";

import * as S from "./styled";

function EmailForm({ onSubmit, ...props }) {
  const [email, setEmail] = useState("");

  function onSubmitHandler(e) {
    e.preventDefault();
    onSubmit(email);
  }

  function onInputHandler({ target }) {
    return setEmail(target.value);
  }

  return (
    <Modal {...props}>
      <S.Form
        method="POST"
        className="input-wrapper"
        onSubmit={onSubmitHandler}
      >
        <S.Label htmlFor="email" className="label">
          Qual é o seu melhor email?
        </S.Label>
        <S.Input
          type="email"
          className="input"
          placeholder="john@email.com"
          required
          onInput={onInputHandler}
        />
        <S.Button type="submit" className="btn submit" disabled={!email}>
          Ver resultado agora
        </S.Button>
      </S.Form>
    </Modal>
  );
}

EmailForm.propTypes = {
  ...ModalType,
  onSubmit: PropTypes.func.isRequired,
};

export default EmailForm;
